import React, { useState } from "react";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function submit(e) {
    e.preventDefault();

    const res = await fetch("https://mys-back.onrender.com/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();

    // ✅ le plus fiable : on se base sur token
    if (data.token) {
      localStorage.setItem("mys_token", data.token);

      // ✅ redirection HOME
      window.location.href = "/";
      return;
    }

    alert(data.error || "Login incorrect");
  }

  return (
    <form onSubmit={submit}>
      <input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Mot de passe"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button type="submit">Connexion</button>
    </form>
  );
}

export default AdminLogin;
